import { Component, OnInit } from '@angular/core';
import { NetworkService } from '../services/network-service/network-service';

@Component({
  selector: 'app-network-status',
  templateUrl: './network-status.component.html',
  styleUrls: ['./network-status.component.scss']
})
export class NetworkStatusComponent implements OnInit {
  isOnline: boolean = true;

  constructor(private networkService: NetworkService) { }

  ngOnInit(): void {
    this.networkService.isOnline$.subscribe(status => {
      this.isOnline = status;
    });
  }
}
